module.exports = __webpack_public_path__ + "img/2.0b556e68.jpg";